import { Box, Button, Text } from "@chakra-ui/react";
import { useRecomendacao } from "../../context/useRecomendacao";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import { usePersonalizacao } from "../../context/usePersonalizacao";

export function Ordenacao({ isOpen, onRequestClose }) {
  const { ordenacao, addOrderFilter, selectedOrder } = useRecomendacao();
  const {personalizacao: {filtros: {filtronaoselecionado, filtroselecionado}}} = usePersonalizacao();

  return (
    <Modal
      className="react-modal-content-ordenacao"
      overlayClassName="react-modal-overlay-ordenacao"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <Box paddingX="1rem" paddingTop="2rem">
        <button
          type="button"
          onClick={onRequestClose}
          className="react-modal-close-ordenacao"
        >
          <FaTimes color="#3E4047" size={18} />
        </button>
        <Text
          fontSize="1.25rem"
          color={filtronaoselecionado.textcolor}
          paddingX="0.5rem"
          fontWeight="normal"
        >
          Ordenar por
        </Text>
        {ordenacao.map((data, index) => (
          <Button
            key={index}
            w="100%"
            type="button"
            display="flex"
            flexDir="row"
            marginTop="1rem"
            paddingX="0.5rem"
            borderRadius="md"
            alignItems="center"
            justifyContent="flex-start"
            border="none"
            onClick={() => {
              addOrderFilter({ order: data });
            }}
            background={
              selectedOrder.filter((selected) => selected.id === data.id)
                .length > 0
                ? filtroselecionado.bgcolor
                : "transparent"
            }
          >
            <data.icon
              color={
                selectedOrder.filter((selected) => selected.id === data.id)
                  .length > 0
                  ? filtroselecionado.textcolor
                  : filtronaoselecionado.textcolor
              }
            />
            <Text
              padding="0.5rem"
              fontSize="1rem"
              color={
                selectedOrder.filter((selected) => selected.id === data.id)
                  .length > 0
                  ? filtroselecionado.textcolor
                  : filtronaoselecionado.textcolor
              }
            >
              {data.label}
            </Text>
          </Button>
        ))}
      </Box>
    </Modal>
  );
}
